const pageNameKey = "unsavedConditionMonitoringForNodeManagerNavigationModal";

export const unsavedConditionMonitoringForNodeManagerNavigationModalEn = {
  [pageNameKey]: {
    subTitle: "Are you sure?",
    title: "Unsaved changes",
    descriptionFirstLine: "Do you really want to proceed without saving?",
    descriptionSecondLine: "All unsaved changes will be discarded.",
    proceedWithoutSavingButton: "Proceed without saving",
    saveConditionMonitoringButtonText: "Save and proceed",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalPtBr = {
  [pageNameKey]: {
    subTitle: "Tem certeza?",
    title: "Alterações não salvas",
    descriptionFirstLine: "Você realmente deseja continuar sem salvar?",
    descriptionSecondLine: "Todas as alterações não salvas serão descartadas.",
    proceedWithoutSavingButton: "Continuar sem salvar",
    saveConditionMonitoringButtonText: "Salvar e continuar",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalDe = {
  [pageNameKey]: {
    subTitle: "Bist du sicher?",
    title: "Ungespeicherte Änderungen",
    descriptionFirstLine: "Möchtest du wirklich fortfahren, ohne zu speichern?",
    descriptionSecondLine:
      "Alle nicht gespeicherten Änderungen gehen verloren.",
    proceedWithoutSavingButton: "Ohne Speichern fortfahren",
    saveConditionMonitoringButtonText: "Speichern und fortfahren",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalZhHans = {
  [pageNameKey]: {
    subTitle: "你确定吗？",
    title: "未保存的更改",
    descriptionFirstLine: "你真的要在不保存的情况下继续吗？",
    descriptionSecondLine: "所有未保存的更改将被丢弃。",
    proceedWithoutSavingButton: "继续而不保存",
    saveConditionMonitoringButtonText: "保存并继续",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalIt = {
  [pageNameKey]: {
    subTitle: "Sei sicuro?",
    title: "Modifiche non salvate",
    descriptionFirstLine: "Vuoi davvero procedere senza salvare?",
    descriptionSecondLine: "Tutte le modifiche non salvate verranno eliminate.",
    proceedWithoutSavingButton: "Procedi senza salvare",
    saveConditionMonitoringButtonText: "Salva e procedi",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalEs = {
  [pageNameKey]: {
    subTitle: "¿Estás seguro?",
    title: "Cambios no guardados",
    descriptionFirstLine: "¿Realmente quieres continuar sin guardar?",
    descriptionSecondLine: "Se descartarán todos los cambios no guardados.",
    proceedWithoutSavingButton: "Continuar sin guardar",
    saveConditionMonitoringButtonText: "Guardar y continuar",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalNl = {
  [pageNameKey]: {
    descriptionFirstLine: "Wilt u echt doorgaan zonder op te slaan?",
    descriptionSecondLine:
      "Alle niet-opgeslagen wijzigingen worden verwijderd.",
    proceedWithoutSavingButton: "Doorgaan zonder op te slaan",
    saveConditionMonitoringButtonText: "Opslaan en doorgaan",
    subTitle: "Weet u het zeker?",
    title: "Niet-opgeslagen wijzigingen",
  },
};

export const unsavedConditionMonitoringForNodeManagerNavigationModalTr = {
  [pageNameKey]: {
    descriptionFirstLine: "Gerçekten kaydetmeden devam etmek istiyor musunuz?",
    descriptionSecondLine: "Kaydedilmemiş tüm değişiklikler silinecektir.",
    proceedWithoutSavingButton: "Kaydetmeden devam et",
    saveConditionMonitoringButtonText: "Kaydet ve devam et",
    subTitle: "Emin misin?",
    title: "Kaydedilmemiş değişiklikler",
  },
};
